module.exports = __webpack_public_path__ + "img/lv_success_4.e4b0619c.png";